module.exports = __webpack_public_path__ + "img/10.028be014.png";